import dataProvider from "../../../../../providers/data-provider";
import DashboardFilter from "./dashboard-filter";

const fetchThemes = async (search) => {
    const response = await dataProvider.getList(
        'themes',
        {
            pagination: { page: 1, perPage: 20 },
            sort: { field: 'theme.name', order: 'ASC' },
            filter: { ['theme.name']: search, has_activities: true }
        })
    return response.data;
}

export const ThemeFilter = ({ filters, setFilters }) => {

    return <DashboardFilter
        filterKey="themeId"
        label="Área do direito"
        value={filters.theme?.id}
        setFilters={setFilters}
        fetchOptions={
            fetchThemes
        }
    />
}